<app-portal-collapsible
    title="Versichertes Instrument"
    icon="instrument"
>
    <dl class="grid-container vertical-gutter-lg">
        <app-portal-widget-details
            class="g-12 sm:g-6"
            heading="Instrumentart"
            [detail]="instrument"
        ></app-portal-widget-details>
        <app-portal-widget-details
            class="g-12 sm:g-6"
            heading="Neupreis"
            detail="{{ price <= 1500 ? 'bis ' : '' }}{{ price | currency: 'EUR' }}"
        ></app-portal-widget-details>
    </dl>
</app-portal-collapsible>
